import { render } from "./RunHistory.vue?vue&type=template&id=66289d46&scoped=true"
import script from "./RunHistory.vue?vue&type=script&lang=js"
export * from "./RunHistory.vue?vue&type=script&lang=js"

import "./RunHistory.vue?vue&type=style&index=0&id=66289d46&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66289d46"]])

export default __exports__